import { LookupRequest } from "./../models/lookup-request";
import { RequestItem } from "../models/request-item";
import { EFileQuestion } from "../models/e-file/e-file-question";
import { NewCivilRequest } from "../models/new-civil/new-civil-request";
import { configs } from "../config";

export const courtConnectBaseUrl = configs.courtConnectBaseUrl;
export const proxyKey = configs.proxyKey;
export const session = configs.session;
export const loggedIn = configs.loggedIn;
// export const caseLookupEndpoint = `${courtConnectBaseUrl}/CaseLookup`;
// export const caseSummaryEndpoint = `${courtConnectBaseUrl}/CaseSummary`;
// export const caseStatusEndpoint = `${courtConnectBaseUrl}/CaseStatus`;
// export const caseDocketEndpoint = `${courtConnectBaseUrl}/CaseDocket`;
// export const caseRemarksEndpoint = `${courtConnectBaseUrl}/CaseRemarks`;
// export const caseBalanceEndpoint = `${courtConnectBaseUrl}/CaseBalance`;
// export const casePaymentsEndpoint = `${courtConnectBaseUrl}/CasePayments`;
// export const casePriorsEndpoint = `${courtConnectBaseUrl}/CasePriors`;
// export const caseAkaEndpoint = `${courtConnectBaseUrl}/CaseAKA`;
// export const caseDetailEndpoint = `${courtConnectBaseUrl}/CaseDetail`;

export const buildLookupRequest = (type?: string, value?: string, value1?: string, value2?: string, value3?: string, value4?: string) => {
    const lookupItems: RequestItem[] = [
        {
            id: 1,
            value: ""
        },
        {
            id: 2,
            value: session
        },
        {
            id: 3,
            value: loggedIn
        },
        {
            id: 4,
            value: type
        },
        {
            id: 5,
            value: value
        },
        {
            id: 6,
            value: value1
        },
        {
            id: 7,
            value: value2
        },
        {
            id: 8,
            value: value3
        },
        {
            id: 9,
            value: value4
        }
    ];

    const lookupRequest: LookupRequest = {
        apiKey: proxyKey,
        items: lookupItems
    };

    return lookupRequest;
};

export const buildSummaryRequest = (caseNumber: string) => {
    const lookupItems: RequestItem[] = [
        {
            id: 1,
            value: ""
        },
        {
            id: 2,
            value: session
        },
        {
            id: 3,
            value: loggedIn
        },
        {
            id: 4,
            value: caseNumber
        }
    ];

    const summaryRequest: LookupRequest = {
        apiKey: proxyKey,
        items: lookupItems
    };

    return summaryRequest;
};
export const civilPaymentRequest = (caseNumber: string, amount?: string, moneyInCode?: string) => {
  const lookupItems: RequestItem[] = [
    {
      id: 1,
      value: caseNumber
    },
    {
      id: 2,
      value: amount
    },
    {
      id: 3,
      value: moneyInCode
    }

  ];

  const paymentRequest: LookupRequest = {
    apiKey: proxyKey,
    items: lookupItems
  };

  return paymentRequest;
};

export const prePaymentRequest = (caseNumber: string, amount?: string, paymentType?: string, customProcess?: string) => {
  const lookupItems: RequestItem[] = [
    {
      id: 1,
      value: caseNumber
    },
    {
      id: 2,
      value: amount
    },
    {
      id: 3,
      value: paymentType
    },
    {
      id: 4,
      value: customProcess
    }

  ];

  const paymentRequest: LookupRequest = {
    apiKey: proxyKey,
    items: lookupItems
  };

  return paymentRequest;
};
export const paymentRequest = (caseNumber: string, value?: string, value1?: string, value2?: string, value3?: string, value4?: string) => {
    const lookupItems: RequestItem[] = [
        {
            id: 1,
            value: caseNumber
        },
        {
            id: 2,
            value: session
        },
        {
            id: 3,
            value: value
        },
        {
            id: 4,
            value: value1
        },
        {
            id: 5,
            value: value2
        },
        {
            id: 6,
            value: value3
        },
        {
            id: 7,
            value: value4
        },
    ];

    const paymentRequest: LookupRequest = {
        apiKey: proxyKey,
        items: lookupItems
    };

    return paymentRequest;
};

export const civilRequest = (condtion: string, value?: string, value1?: string, value2?: string, value3?: string, value4?: string) => {
    const lookupItems: RequestItem[] = [
        {
            id: 1,
            value: condtion
        },
        {
            id: 2,
            value: value
        },
        {
            id: 3,
            value: value1
        },
        {
            id: 4,
            value: value2
        },
        {
            id: 5,
            value: value3
        },
        {
            id: 6,
            value: value4
        }
    ];

    const civilRequest: LookupRequest = {
        apiKey: proxyKey,
        items: lookupItems
    };

    return civilRequest;
};

export const buildAgencyRequest = (value?: string, value1?: string, value2?: string, value3?: string, value4?: string, value5?: string, value6?: string) => {
    const lookupItems: RequestItem[] = [
        {
            id: 1,
            value: ""
        },
        {
            id: 2,
            value: ""
        },
        {
            id: 3,
            value: session
        },
        {
            id: 4,
            value: value
        },
        {
            id: 5,
            value: value1
        },
        {
            id: 6,
            value: value2
        },
        {
            id: 7,
            value: value3
        },
        {
            id: 8,
            value: value4
        },
        {
            id: 9,
            value: value5
        },
        {
            id: 10,
            value: value6
        }
    ];

    const agencyRequest: LookupRequest = {
        apiKey: proxyKey,
        items: lookupItems
    };

    return agencyRequest;
};

export const buildEFileOptionsRequest = (value?: string, value1?: string) => {
    const lookupItems: RequestItem[] = [
        {
            id: 1,
            value: value
        },
        {
            id: 2,
            value: session
        },
        {
            id: 3,
            value: loggedIn
        },
    ];

    const eFileOptionsRequest: LookupRequest = {
        apiKey: proxyKey,
        items: lookupItems
    };

    return eFileOptionsRequest;
};

export const buildEFileRequest = (caseNumber, eFileOption, eFileAnswers: EFileQuestion[]) => {
    const eFileObject =
    {
        User: loggedIn,
        CaseNumber: caseNumber,
        EFileOptionId: eFileOption,
        Answers: eFileAnswers
    };

    const eFileRequest = {
        ApiKey: proxyKey,
        Object: eFileObject
    };

    return eFileRequest;
};

export const buildCivilEFileRequest = (eFileObject: NewCivilRequest) => {

  const civilRequest = {
    ApiKey: proxyKey,
    Object: eFileObject
  };

  return civilRequest;
};

export const buildCivilPrepaymentRequest = (caseId, paymentAmount, moneyInCode) => {
  const prepaymentRequest = {
    ApiKey: proxyKey,
    Items: [
      {
        id: 1,
        data: caseId
      },
      {
        id: 2,
        data: paymentAmount
      },
      {
        id: 3,
        data: moneyInCode
      }
    ]
  };

  return prepaymentRequest;
};


export const buildCivilPostpaymentRequest = (transactionId, caseId, paymentAmount, reference, dateTimePaid, remoteAddress) => {
  const postpaymentRequest = {
 
    ApiKey: proxyKey,
    Items: [
      {
        id: 1,
        data: transactionId
      },
      {
        id: 2,
        data: caseId
      },
      {
        id: 3,
        data: paymentAmount
      },
      {
        id: 4,
        data: reference
      },
      {
        id: 5,
        data: dateTimePaid
      },
      {
        id: 6,
        data: remoteAddress
      },
    ]
  };
  return postpaymentRequest;
};

export const buildPaymentConfigRequest = (processor) => {
  const paymentConfigRequest = {

    ApiKey: proxyKey,
    Items: [
      {
        id: 1,
        value: processor
      }
    ]
  };
  return paymentConfigRequest;
}